import { Box, Grid, SkeletonCircle, Text } from '@chakra-ui/react'

import { StatChangeValue } from '@/containers/dashboard/Stats/StatChangeValue'

import { formatNumber } from '@/utils/formatNumber'
import type { CircularProgressProps } from './CircularProgress'
import { CircularProgress } from './CircularProgress'

export interface CircularProgressWithStatsProps extends CircularProgressProps {
  value?: number
  valueUnit?: string
  isLoading: boolean
  color?: string
  previousValue?: number
  previousValueLabel?: string
}

export const CircularProgressWithStats = ({
  value,
  valueUnit,
  previousValue,
  previousValueLabel,
  isLoading,
  ...rest
}: CircularProgressWithStatsProps) => {
  const width = '120px'
  const height = '120px'

  return (
    <Box sx={{ position: 'relative', w: width, h: height }}>
      <SkeletonCircle isLoaded={!isLoading} width={width} height={height}>

        <CircularProgress
          sx={{ position: 'relative' }}
          percentage={value}
          {...rest}
        />

        <Grid
          sx={{
            p: 4,
            position: 'absolute',
            inset: 0,
            gap: 1,
            w: '100%',
            h: '100%',
            placeContent: 'center',
            placeItems: 'center',
          }}
        >
          <Text sx={{ fontSize: '3xl', fontWeight: 'medium', lineHeight: '1' }}>
            {formatNumber(value, { maximumFractionDigits: 0 })} {valueUnit}
          </Text>

          <StatChangeValue mt={-1} mb={-3} size="sm"
            value={value}
            baselineValue={previousValue}
            baselineValueLabel={previousValueLabel}
            relative={false}
            maxFractionDigits={0}
            absoluteUnit='%' />
        </Grid>

      </SkeletonCircle>
    </Box>
  )
}
